module.exports = __webpack_public_path__ + "static/rave-f160335ec53dd7110805de7847d9e309.jpg";